import {ReactElement} from "react";
import {Redirect, Route, Switch} from "react-router-dom";
import {Users} from "../pages/admin/users/Users";
import {UserManagerNavBar} from "../components/navbar/UserManagerNavBar";
import css from "./main/mainRoute.module.scss";

export function UserManagerRoute(): ReactElement {
    return (
        <div className={css.appWrapper}>
            <div className={css.navWrapper}>
                <UserManagerNavBar />
            </div>
            <div className={css.contentWrapper}>
                <Switch>
                    <Route exact path="/admin/users" component={Users} />
                    <Route path="*">
                        <Redirect to="/admin/users" />
                    </Route>
                </Switch>
            </div>
        </div>
    );
}
